import React from 'react';
import TermsAndConditions from './components/TermsAndConditions';
import './App.css';

function App() {
  return (
    <div className="App">
      <TermsAndConditions />
    </div>
  );
}

export default App;
